import styled from 'styled-components'

import SectionWrapper from '../../../components/SectionWrapper'
import { mq, sizes } from '../../../theme'
import AdsSortingFilters from '../../../components/AdsSortingFilters'
import PublicationGuideSmallCard from '../../../components/PublicationGuideSmallCard'
import Icon from '../../../components/Icon'

export const Section = styled(SectionWrapper)`
  position: relative;

  @media ${mq(sizes.desktop)} {
    background-color: ${({ theme }) => theme.colors.blueBack};
    padding: 0 7rem 3.5rem 7rem;
  }
`

export const SortingFiltersAds = styled(AdsSortingFilters)`
  @media ${mq(sizes.desktop)} {
    margin-top: -8rem;
    position: relative;
  }
`
export const SmallCardPublicationGuide = styled(PublicationGuideSmallCard)`
  max-width: 92.2rem;
  margin: 3.5rem -2rem 0 -2rem;

  @media ${mq(sizes.desktop)} {
    margin: 3.5rem auto 0 auto;
  }
`

export const CrossesIcon = styled(Icon)`
  position: absolute;
  right: -6.5rem;
  bottom: 3rem;

  @media ${mq(null, sizes.scoping)} {
    display: none;
  }
`
